import CreditCardProgram from 'components/RwdBasket/RwdBasketLayout/BIBenefits/CreditCardProgram/CreditCardProgram';

export default CreditCardProgram;
